import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14 gap-3">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              本周热榜
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              人气爆款排行
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              根据阅读量、互动数和收藏数综合排序的本周最受欢迎内容
            </p>
          </div>
          <span className="text-xs text-foreground-500 whitespace-nowrap">每周一更新</span>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 md:p-5 hover:bg-background-200/70 transition-colors duration-200 group cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex-shrink-0 flex items-center justify-center rounded-xl font-heading font-bold text-lg ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-400/80 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-300/80 text-background-50'
                  : 'bg-secondary-200 text-secondary-700'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-1 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500 flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>

              <div className="flex-shrink-0">
                {item.trend === 'up' && (
                  <span className="flex items-center gap-1 text-xs text-green-600 font-medium whitespace-nowrap">
                    <i className="ri-arrow-up-line"></i>上升
                  </span>
                )}
                {item.trend === 'new' && (
                  <span className="flex items-center gap-1 text-xs text-accent-600 font-medium whitespace-nowrap">
                    <i className="ri-sparkling-line"></i>新晋
                  </span>
                )}
                {item.trend === 'stable' && (
                  <span className="flex items-center gap-1 text-xs text-foreground-500 font-medium whitespace-nowrap">
                    <i className="ri-subtract-line"></i>稳定
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}